import { useScopedTranslate } from '@locale/translate';

export const translations = {
  en: {
    'account-number': 'Account number must be 6 digits or less',
    'bank-number': 'Bank number must be 4 digits or less',
    'color-code': 'Please enter a valid color code',
    'no-default-value': 'This field is required',
    'valid-http-url': 'Please enter a valid url',
    password: 'Password must be at least 6 characters long',
    email: 'Please enter a valid email address',
    ledger: 'Ledger must be 2 digits',
    number: 'Input should only contain numbers',
    decimal: 'Input is not a valid decimal number',
    phone: 'Please use a valid phone number',
    required: 'This field is required',
    ssn: 'Please enter a valid SSN',
    translation: 'Translation missing',
    maxCharacters: 'The maximum text length is 340 characters.',
    'positive-number': 'Please enter a positive number',
    json: 'Please enter a valid JSON string',
    'json-template': 'Please enter valid JSON',
    url: 'Please enter a valid URL (including http:// or https://)',
    'sms-sender-name': 'Invalid name',
    'email-sender-name': 'Invalid name (can not contain the following characters: , ; < > ")',
    'business-email': 'Please enter a valid business email',
    'min-number': 'Must be greater than or equal to {min}',
    'max-number': 'Must be less than or equal to {max}',
    'no-negative-number': 'Negative numbers are not allowed',
    'file-type': 'Unsupported file format',
  },
  is: {
    'account-number': 'Reikningsnúmer þarf að vera 6 eða færri tölustafir',
    'bank-number': 'Bankanúmer þarf að vera 4 eða færri tölustafir',
    'color-code': 'Vinsamlegast notaðu gildan litakóða',
    'no-default-value': 'Nauðsynlegt er að fylla þennan reit út',
    'valid-http-url': 'Vinsamlegast notaðu löglega slóð',
    password: 'Password must be at least 6 characters long',
    email: 'Vinsamlega notaðu gilt netfang',
    ledger: 'Höfuðbók þarf að vera 2 tölustafir',
    number: 'Einungis má skrá tölustafi',
    decimal: 'Vinsamlegast sláið inn gilda tölu t.d. 10.0',
    phone: 'Vinsamlega notaðu gilt símanúmer',
    required: 'Nauðsynlegt er að fylla þennan reit út',
    ssn: 'Vinsamlega notaðu gilda kennitölu',
    translation: 'Þýðingu vantar',
    maxCharacters: 'Hámarks lengd texta er 340 stafir.',
    'positive-number': 'Vinsamlega sláðu inn jákvæða tölu',
    json: 'Vinsamlega notaðu gildan JSON streng',
    'json-template': 'Sláðu inn gildan JSON',
    url: 'Vinsamlega notaðu gilda vefslóð (með http:// eða https://)',
    'sms-sender-name': 'Nafn uppfyllir ekki skilyrði',
    'email-sender-name':
      'Nafn uppfyllir ekki skilyrði (getur ekki innihaldið eftirfarandi stafi: , ; < > ")',
    'business-email': 'Vinsamlega notaðu gilt fyrirtækjanetfang',
    'min-number': 'Verður að vera stærra eða jafnt og {min}',
    'max-number': 'Verður að vera minna eða jafnt og {max}',
    'no-negative-number': 'Neikvæðar tölur eru ekki leyfðar',
    'file-type': 'Óleyfilegt skráarsnið',
  },
  dk: {
    'account-number': 'Account number must be 6 digits or less',
    'bank-number': 'Bank number must be 4 digits or less',
    'color-code': 'Please enter a valid color code',
    'no-default-value': 'Dette felt er påkrævet',
    'valid-http-url': 'Indtast venligst en gyldig url',
    password: 'Adgangskoden skal være mindst 6 tegn lang',
    email: 'Please enter a valid email address',
    ledger: 'Ledger must be 2 digits',
    number: 'Input bør kun indeholde tal',
    decimal: 'Input bør kun indeholde tal',
    phone: 'Please use a valid phone number',
    required: 'Dette felt er påkrævet',
    ssn: 'CPR nummer ikke korrekt udfyldt',
    translation: 'Oversættelse mangler',
    maxCharacters: 'Den maksimale tekstlængde er 340 tegn.',
    'positive-number': 'Indtast venligst et positivt tal',
    'min-number': 'Skal være større end eller lig med {min}',
    'max-number': 'Skal være mindre end eller lig med {max}',
    'no-negative-number': 'Negative tal er ikke tilladt',
    'file-type': 'Filformatet er ikke tilladt',
  },
};

export const useFormTranslations = () => useScopedTranslate(translations);

export const isFormError = (error: string): error is keyof typeof translations.en => {
  return error in translations.en;
};
